import { MenuItem } from '../models/sidebar';

const createMenuItem = (
  id: string,
  name: string,
  path: string,
  icon?: MenuItem['icon'],
  options: Partial<Omit<MenuItem, 'id' | 'name' | 'path' | 'icon'>> = {}
): MenuItem => ({
  id,
  name,
  path,
  icon,
  ...options,
});

/**
 * Primary nav — mirrors prototype app-shell.js NAV:
 * Audience · Campaigns · Reports (+ Settings pinned separately).
 * Dashboard was removed from the prototype primary nav (2026-09-22 reports
 * restructure); reports overview is the analytics entry point.
 */
export const menuItems: MenuItem[] = [
  createMenuItem('contacts', 'Contacts', '/contacts', 'UsersThree'),
  createMenuItem('lists', 'Lists', '/lists', 'ListBullets'),
  createMenuItem('segments', 'Segments', '/segments', 'Funnel'),
  createMenuItem('suppression', 'Suppression', '/suppression', 'Prohibit'),
  createMenuItem('campaigns', 'Campaigns', '/campaigns', 'Megaphone'),
  createMenuItem('templates', 'Templates', '/templates', 'FileText'),
  createMenuItem('media-library', 'Media library', '/media-library', 'ImageSquare'),
  createMenuItem('reports-overview', 'Overview', '/reports/overview', 'ChartDonut'),
  createMenuItem(
    'reports-deliverability',
    'Deliverability',
    '/reports/deliverability',
    'ShieldCheck'
  ),
  createMenuItem('settings', 'Settings', '/settings', 'Gear'),
];
